import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import authRoles from '@auth/authRoles';

const DocumentationHubView = lazy(() =>
	import('./components/views/DocumentationHubView').then((m) => ({ default: m.DocumentationHubView }))
);
const SpecModuleView = lazy(() =>
	import('./components/views/SpecModuleView').then((m) => ({ default: m.SpecModuleView }))
);

const documentationRoutes: FuseRouteItemType[] = [
	{ path: 'documentation', element: <DocumentationHubView /> },
	{ path: 'documentation/:guideId', element: <DocumentationHubView /> },
	{ path: 'documentation/specs/:module', element: <SpecModuleView />, auth: authRoles.admin }
];

export default documentationRoutes;
